import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { useLaunch } from '../contexts/LaunchContext';
const features = ['Unlimited kitties for every group', 'Invite by link, code, QR or contacts', 'Equal or custom splits on any spend', 'See clearly who needs to pay whom', 'Settle up and confirm together', 'My Balance across every kitty'];
export function Pricing() {
  const {
    isPublicLaunch
  } = useLaunch();
  const scrollToCta = () => document.getElementById('get-started')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section id="pricing" className="py-28 lg:py-36 bg-gray-50" data-id="element-197" data-mp="25shkas7zyx51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198" data-mp="20t4pnlavwlrw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-199" data-mp="20rtl3j9m79zq">
          <p className="text-sm font-semibold text-kitty-yellow-600 uppercase tracking-widest mb-3" data-id="element-200" data-mp="3vyf5inb5srzq">
            Pricing
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-201" data-mp="4rb2s4m1rrx4">
            {isPublicLaunch ? 'Free to use.' : 'Free during early access.'}
          </h2>
          <p className="text-lg text-gray-500 max-w-lg mx-auto" data-id="element-202" data-mp="eqtiu9yu6tjw">
            Every feature, every kitty, every member — £0.
          </p>
        </motion.div>

        <div className="max-w-lg mx-auto" data-id="element-203" data-mp="3i7irq2lw6fcq">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-card border border-gray-100 relative overflow-hidden" data-id="element-204" data-mp="3i8boqbv1tqho">
            {/* Yellow top accent line */}
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-kitty-yellow" data-id="element-205" data-mp="2zg9gnowh3ij1" />

            <div className="text-center mb-10 mt-2" data-id="element-206" data-mp="2rg33i109nume">
              <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-medium mb-4" data-id="element-207" data-mp="2rei9qdls0fpl">
                <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-208" data-mp="3177ll9l8nvlg" />
                {isPublicLaunch ? 'No subscription' : 'Early access pricing'}
              </p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-209" data-mp="2w9xm1144y3jw">
                <span className="text-5xl md:text-6xl font-extrabold text-kitty-dark" data-id="element-210" data-mp="28i8z60a327ac">
                  £0
                </span>
                <span className="text-gray-500 text-lg" data-id="element-211" data-mp="2ig6lgi8dtu0b">/month</span>
              </div>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-212" data-mp="2dh3j55jse1w1">
              {features.map(feature => <li key={feature} className="flex items-center gap-3" data-id="element-213" data-mp="3tvbq3rs2q2mk">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center" data-id="element-214" data-mp="3ttijgchgniek">
                    <CheckIcon className="w-3.5 h-3.5 text-green-700" aria-hidden="true" data-id="element-215" data-mp="3oylaf5k6l91o" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-216" data-mp="5arte9kob5hk">{feature}</span>
                </li>)}
            </ul>

            <button onClick={scrollToCta} className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark py-4 rounded-full font-bold text-lg transition-colors duration-150 active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-dark" data-id="element-217" data-mp="3rgosn5eodsjb">
              {isPublicLaunch ? 'Download KittyPot' : 'Join the waitlist'}
              <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-218" data-mp="e8lq3lmco159" />
            </button>

            {!isPublicLaunch && <p className="text-center text-xs text-gray-500 mt-5 font-medium" data-id="element-219" data-mp="11xwhicht8j6q">
                🚀 Limited spots — join early access now
              </p>}
          </motion.div>
        </div>
      </div>
    </section>;
}